// const initialState = {
//   ShowModal: false,
// }

// export default function includeAnnotationsConfirmModalReducer(
//   state = initialState,
//   action: any
// ) {
//   switch (action.type) {
//     case "INCLUDE_ANNOTATIONS_CONFIRM_MODAL":
//       return {
//         ...state,

//         ShowModal: action.payload.ShowModal,
//       }
//     default:
//       return state
//   }
// }







const initialState = false;
const includeAnnotationsConfirmModalReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "INCLUDE_ANNOTATIONS_CONFIRM_MODAL":
      return action?.payload;
      break;
    default:
      return state;
  }
};

export default includeAnnotationsConfirmModalReducer;

